export enum EmailType {
  Attachment = 'Attachment',
  BodyImage = 'BodyImage',
  BodyLink = 'BodyLink',
  BodyParagraph = 'BodyParagraph',
  DateHeader = 'DateHeader',
  Header = 'Header',
  Signature = 'Signature',
  Subject = 'Subject',
}
